import { render, staticRenderFns } from "./MarketCatalogCard.vue?vue&type=template&id=00439b68&"
import script from "./MarketCatalogCard.vue?vue&type=script&lang=js&"
export * from "./MarketCatalogCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports